import { ArrowLeftIcon } from "@phosphor-icons/react";

import Button, { ButtonSize, ButtonVariant } from "@gx/dls/buttons/Button";
import FlexWrapper, { AlignItems } from "@gx/dls/containers/FlexWrapper";
import { SourceType } from "@gx/ts-contracts/services/database/models/public_pb";

import BaseHeader from "@/layouts/components/BaseHeader";

import SourceIcon from "@/pages/sources/components/SourceIcon";
import {
  SOURCE_TYPE_TO_DESCRIPTION_MAP,
  SOURCE_TYPE_TO_LABEL_MAP,
} from "@/pages/sources/constants";

interface CreateSourceModalHeaderProps {
  sourceType: SourceType;
  onClose: () => void;
  onBack: () => void;
}

const CreateSourceModalHeader = ({ sourceType, onClose, onBack }: CreateSourceModalHeaderProps) => {
  const sourceLabel = SOURCE_TYPE_TO_LABEL_MAP[sourceType];
  const sourceDescription = SOURCE_TYPE_TO_DESCRIPTION_MAP[sourceType];

  return (
    <FlexWrapper alignItems={AlignItems.CENTER} padding="16px" gap={12} fillWidth>
      <Button
        icon={ArrowLeftIcon}
        variant={ButtonVariant.TERTIARY}
        size={ButtonSize.SMALL}
        onClick={onBack}
      />
      <FlexWrapper alignItems={AlignItems.CENTER} gap={12} fillWidth>
        <SourceIcon sourceType={sourceType} />
        <BaseHeader
          title={`New ${sourceLabel} data source`}
          description={sourceDescription}
          onClose={onClose}
        />
      </FlexWrapper>
    </FlexWrapper>
  );
};

export default CreateSourceModalHeader;
